import { POST_AUTH_SERVICES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { updateAuthDestinationServicesBuyer } from 'modules/authorizations/store/actions/destinationService.actions';
import { postCandidateServices, updateCandidateServices } from 'modules/authorizations/store/actions/canidateTrip.actions';
import { postServices, updateAuthorizationSummary, updateServices } from 'modules/authorizations/store/actions/authorizations.actions';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';
import ServicesEditableCard from './servicesEditableCard.component';
import { ZERO_GUID } from './destinationServices/destinationServicesDetailsEditableCard.component';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { AUTHORIZATION_FILE_STATUS_IDS } from 'modules/enumerations/enumerationIds';
import { UPDATE_AUTHORIZATIONS_FAILURE } from '../types';

const ServicesCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const authServices = Array.isArray(props.authServices) ? props.authServices : [];
  const surveyInfo = props.surveyInfo ? props.surveyInfo : [];
  const webAccess = props.webAccess ? props.webAccess : '';

  const fileStatusOptions =
    props.enumerations && props.enumerations.allEnums && Array.isArray(props.enumerations.allEnums.authorizationFileStatuses)
      ? props.enumerations.allEnums.authorizationFileStatuses.filter(s => s.isActive)
      : [];

  const authDetails = props.authorizationDetails;
  const currentStatus =
    authDetails && fileStatusOptions
      ? fileStatusOptions.find(s => isIdEqual(s.id, authDetails.authorizationFileStatusId))
      : { id: ZERO_GUID, title: '' };

  const globalStatusId = props.details?.global?.globalInfo?.statusId;
  const globalStatus = globalStatusId && !isIdEqual(globalStatusId, ZERO_GUID)
    ? props.enumerations?.allEnums?.globalServiceStatusTypes?.find(s => isIdEqual(s.id, globalStatusId))?.title
    : 'Initiated';
  const globalService = authServices.find(s => s.authorizationFileServiceTypeId === 'e5c3355e-9171-4968-a142-1a9d643a4b7d');

  let authServicesFlatMap = {
    temporaryLiving: authServices && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139') && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').serviceStatus
      : null,
    homefindRenter: authServices && authServices.find(s => s.authorizationFileServiceTypeId === '1f0148df-2898-4d52-88f1-03f8ceafb74f') && authServices.find(s => s.authorizationFileServiceTypeId === '1f0148df-2898-4d52-88f1-03f8ceafb74f').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === '1f0148df-2898-4d52-88f1-03f8ceafb74f').serviceStatus
      : null,
    candidate: authServices && authServices.find(s => s.authorizationFileServiceTypeId === '3458d47e-95fd-4d57-b5f1-29e720c74d4f') && authServices.find(s => s.authorizationFileServiceTypeId === '3458d47e-95fd-4d57-b5f1-29e720c74d4f').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === '3458d47e-95fd-4d57-b5f1-29e720c74d4f').serviceStatus
      : null,
    homefindBuyer: authServices && authServices.find(s => s.authorizationFileServiceTypeId === '007e4298-676f-4e50-8791-fa6464cd5358') && authServices.find(s => s.authorizationFileServiceTypeId === '007e4298-676f-4e50-8791-fa6464cd5358').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === '007e4298-676f-4e50-8791-fa6464cd5358').serviceStatus
      : null,
    householdGoods: authServices && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a') && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').serviceStatus
      : null,
    global: globalService?.isEnabled
      ? (props.details?.global?.globalInfo && globalStatus) || globalService.serviceStatus
      : null,
    homesale: authServices && authServices.find(s => s.authorizationFileServiceTypeId === '7b17cb15-a7d3-4b23-931a-ded0d4cf54a5') && authServices.find(s => s.authorizationFileServiceTypeId === '7b17cb15-a7d3-4b23-931a-ded0d4cf54a5').isEnabled
      ? authServices.find(s => s.authorizationFileServiceTypeId === '7b17cb15-a7d3-4b23-931a-ded0d4cf54a5').serviceStatus
      : null,
    // HHG and temp living report a status per segment / per stay rather than a single service level status.
    hhgSegments: authServices && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a') && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').isEnabled
      && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').hhgSegments && authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').hhgSegments.length > 0
      ? authServices.find(s => s.authorizationFileServiceTypeId === 'cce24947-254f-431a-97a9-2a1469161b8a').hhgSegments
      : null,
    tempLivingStatuses: authServices && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139') && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').isEnabled
      && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').tempLivingStatuses && authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').tempLivingStatuses.length > 0
      ? authServices.find(s => s.authorizationFileServiceTypeId === 'a6431f21-754e-4546-8511-12e74170f139').tempLivingStatuses
      : null,
    fileId: props.id
  };


  if(authServicesFlatMap.homesale != null && authServicesFlatMap.homesale === '')
  {
    authServicesFlatMap.homesale = 'Initiated';
  }

  // comment

  /*
        If value = empty string or null => status = disabled
        From the card editing modal:
            If value = 'true' (checkbox is clicked) then status = init
            If value = 'false' (checkbox is unclicked) then status = disabled

        Customized Services editable card

    */

  const updateFields = async (temporaryLiving, homesale, global, homefindRenter, candidateServices, householdGoods, homefindBuyer) => {
    setIsLoading(true);

    let newServiceList = [...props.authServices];

    const upsertServiceState = (serviceTypeId, isEnabled) => {
      const existingIndex = newServiceList.findIndex(
        s => (s.AuthorizationFileServiceTypeId || s.authorizationFileServiceTypeId) === serviceTypeId
      );

      if (existingIndex >= 0) {
        const existing = newServiceList[existingIndex];
        newServiceList[existingIndex] = {
          ...existing,
          FileId: existing.FileId || existing.fileId || props.id,
          AuthorizationFileServiceTypeId: serviceTypeId,
          IsEnabled: isEnabled,
          isEnabled: isEnabled
        };
        return;
      }

      newServiceList.push({
        FileId: props.id,
        AuthorizationFileServiceTypeId: serviceTypeId,
        IsEnabled: isEnabled
      });
    };

    upsertServiceState('a6431f21-754e-4546-8511-12e74170f139', temporaryLiving === 'Initiated');
    upsertServiceState('e5c3355e-9171-4968-a142-1a9d643a4b7d', global === 'Initiated');
    upsertServiceState('1f0148df-2898-4d52-88f1-03f8ceafb74f', homefindRenter === 'Initiated');
    upsertServiceState('cce24947-254f-431a-97a9-2a1469161b8a', householdGoods === 'Initiated');
    upsertServiceState('7b17cb15-a7d3-4b23-931a-ded0d4cf54a5', homesale === 'Initiated');
    upsertServiceState('3458d47e-95fd-4d57-b5f1-29e720c74d4f', candidateServices === 'Initiated');
    upsertServiceState('007e4298-676f-4e50-8791-fa6464cd5358', homefindBuyer === 'Initiated');

    const resp = await props.postServices(props.id, newServiceList);
    if (resp.type === POST_AUTH_SERVICES_FAILURE) {
      props.showToast('Failed to update the employee services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      props.showToast('Authorizations services updated successfully.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      setIsLoading(false);
      return true;
    }
  };

  const updateStatusFields = async nextStatusId => {
    setIsLoading(true);

    let newVals = { ...props.authorizationDetails };
    newVals.authorizationFileStatusId = nextStatusId;
    if (
      isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.ACTIVE) ||
      isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.PENDING) ||
      isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.ON_ASSIGNMENT) ||
      isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.INIT)
    ) {
      newVals.opsClosedDate = null;
      newVals.completedDate = null;
      newVals.cancelledDate = null;
    }

    if (isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.CANCELLED)) {
      newVals.cancelledDate = new Date().toISOString();
      newVals.opsClosedDate = null;
      newVals.completedDate = null;
    }

    if (isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.OPS_CLOSED)) {
      newVals.opsClosedDate = new Date().toISOString();
      newVals.completedDate = null;
      newVals.cancelledDate = null;
    }

    if (isIdEqual(nextStatusId, AUTHORIZATION_FILE_STATUS_IDS.CLOSED)) {
      newVals.completedDate = new Date().toISOString();
      newVals.opsClosedDate = null;
      newVals.cancelledDate = null;
    }

    const resp = await props.updateAuthorizationSummary(newVals);
    if (resp.type === UPDATE_AUTHORIZATIONS_FAILURE) {
      props.showToast('Failed to update the auth summary info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  return (
    <ServicesEditableCard
      status={currentStatus}
      webAccess={webAccess}
      surveyInfo={surveyInfo}
      servicesInfo={authServicesFlatMap}
      numColumns={4}
      updateFields={updateFields}
      isLoading={isLoading}
      updateStatusFields={updateStatusFields}
      hideEdit={Boolean(props.hideEdit)}
    />
  );
};

export default compose(
  connect(null, {
    postServices,
    updateServices,
    updateAuthDestinationServicesBuyer,
    postCandidateServices,
    updateCandidateServices,
    showToast,
    updateAuthorizationSummary
  })
)(ServicesCard);
